<div class="asset-container">
    <h4 class=" pt-5 pb-3  font-weight-bold d-block">
      {{title}}
    </h4>

    <div class="main">
        <a href="{{mailTemplate | deloitteaiBuildEmailLink:mailData}}" class="btn btn-primary">
            request this asset
        </a>
        <img src="../../../../../../assets/img/covid19.png">
    </div>
</div>
